/* eslint-disable react/display-name */
import React from 'react';
import { Label, SelectField, ErrorMessage } from '../FormikCustom';

const Select = React.forwardRef(({ name, label, required, forceError, ...rest }, ref)=>
{
    let className = 'react-select';
    if (forceError)
        className += ' error';

  return (
    <div className="form-group">
      <Label required={required} htmlFor={name}>{label}</Label>
          <SelectField ref={ref} name={name} className={className} {...rest} />
      <ErrorMessage name={name} />
    </div>
  );
});

export default Select;
//Default OnChange Select save entire option object {label:'', value:''} this wrapper change to save only option.value usefully on Formik Forms
export const SelectValue = React.forwardRef((props, ref)=> {
  return <Select {...props} ref={ref} setOnlyValueOnChange />;
});

